import { render } from "./GetCertifiedSectionApplicant.vue?vue&type=template&id=94516a6c&scoped=true"
import script from "./GetCertifiedSectionApplicant.vue?vue&type=script&lang=js"
export * from "./GetCertifiedSectionApplicant.vue?vue&type=script&lang=js"

import "./GetCertifiedSectionApplicant.vue?vue&type=style&index=0&id=94516a6c&lang=postcss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94516a6c"]])

export default __exports__